var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import styles from './video-list-page.styles';
// import {classMap} from 'lit/directives/class-map.js';
import '../video-list/video-list';
import '../breadcrumbs/breadcrumbs';
import '../breadcrumbs/breadcrumb-item/breadcrumb-item';
import { ifDefined } from 'lit/directives/if-defined.js';
import { dictionary } from '@mf-cms/helpers';
let PVideoListPage = class PVideoListPage extends LitElement {
    constructor() {
        super(...arguments);
        this.videos = [];
        this.liveVideos = [];
        this.openFoldersInTree = [];
        this.titleSignature = '';
        this.items = 0;
        this.heading = '';
        this.videoBaseUrl = '';
        this.LiveBaseUrl = '';
        this.baseUrl = '';
        this.showLatest = false;
        this.culture = 'en-GB';
        this.showRuntime = false;
        this.subFolders = (parent, folderTree) => {
            return html ` <p-folder-tree slot="sub" sub> ${folderTree?.filter((f) => f.parent == parent)?.map((folder) => html `
              <p-folder
                @p-folder-select=${(e) => this.pickFolder(e, folder)}
                @p-folder-toggle-open=${() => {
                folder.open = !folder.open;
                this.requestUpdate();
            }}
                ?selected=${folder.id == this.folderId}
                ?open=${folder.hasChildren && (this.isFolderOpen(folder) || folder.open)}
                hide-icon
                folder-id=${folder.id}
                level=${folder.depth}
                ?has-sub-folders=${folder.hasChildren}
                folder-title=${folder.name}
                culture=${this.culture}
              >
                ${folder.name}
                ${folder.hasChildren && (this.isFolderOpen(folder) || folder.open)
                ? this.subFolders(folder.id, folderTree)
                : ''}
              </p-folder>
            `)}
      </p-folder-tree>
    `;
        };
    }
    static { this.styles = styles; }
    async getVideos(folderId) {
        if (folderId == 'latest' || isNaN(folderId)) {
            try {
                const response = await fetch(`${process.env.API_URL}/files/latest?fields=any&type=video&access_token=${this.accessToken}`);
                const json = await response.json();
                //TODO: log?
                return json;
            }
            catch (e) {
                console.error(e);
            }
            return [];
        }
        try {
            const response = await fetch(`${process.env.API_URL}/folder/${folderId}/files?fields=any&type=video&access_token=${this.accessToken}`);
            const json = await response.json();
            window.dispatchEvent(new CustomEvent('action', {
                detail: {
                    type: 'listFilesInFolder',
                    id: folderId,
                    culture: this.culture
                }
            }));
            return json;
        }
        catch (e) {
            console.error(e);
        }
        return [];
    }
    async getLiveVideos(folderId) {
        if (folderId == 'latest') {
            return [];
        }
        try {
            const response = await fetch(`${process.env.API_URL}/folder/${folderId}/livestreams?fields=any&access_token=${this.accessToken}`);
            const json = await response.json();
            return json;
        }
        catch (e) {
            console.error(e);
        }
        return [];
    }
    async getFolderTree() {
        const response = await fetch(`${process.env.API_URL}/foldertree?fields=any&access_token=${this.accessToken}`);
        const json = await response.json();
        return json;
    }
    async getFolder(folderId) {
        if (folderId == 'latest') {
            return {
                id: 'latest',
                name: await dictionary(this.culture, 'videosPage', 'latest'),
                parents: []
            };
        }
        const response = await fetch(`${process.env.API_URL}/folder/${folderId}?fields=any&access_token=${this.accessToken}`);
        const json = await response.json();
        return json[0];
    }
    //on created
    async firstUpdated() {
        this.titleSignature = document.title;
        this.accessToken = window.getAccessToken();
        this.folderTree = await this.getFolderTree();
        if (this.showLatest) {
            this.folderTree.unshift({
                id: 'latest',
                name: await dictionary(this.culture, 'menu', 'latest'),
                hasChildren: false,
                depth: 0
            });
        }
        if (!this.folderId && this.folderTree.length > 0) {
            this.folderId = this.folderTree[0].id;
            // window.history.pushState({}, '', `${this.baseUrl}/${this.folderId}`);
        }
        this.pickedFolder = await this.getFolder(this.folderId);
        this.videos = await this.getVideos(this.folderId);
        this.liveVideos = await this.getLiveVideos(this.folderId);
        document.title = `${this.pickedFolder.name} ${this.titleSignature}`;
        // start live ticker for live videos, update every 10 seconds
        this.interval = setInterval(async () => {
            this.liveVideos = await this.getLiveVideos(this.folderId);
        }, 10000);
    }
    disconnectedCallback() {
        clearInterval(this.interval);
        super.disconnectedCallback();
    }
    updated() {
        this.openFoldersInTree = [...this.folderTreeElement?.querySelectorAll('p-folder')]
            .filter((f) => f.open && f.children.length > 0)
            .map((x) => x.folderId.toString());
    }
    async pickFolder(e, folder) {
        const selectedFolderComponent = e.target;
        const selectedId = selectedFolderComponent.folderId;
        window.history.pushState({}, '', `${this.baseUrl}/${selectedId}`);
        this.folderId = selectedId;
        this.pickedFolder = await this.getFolder(selectedId);
        document.title = `${this.pickedFolder.name} ${this.titleSignature}`;
        this.videos = await this.getVideos(selectedId);
        this.liveVideos = await this.getLiveVideos(selectedId);
        this.videoHeaderElement && this.videoHeaderElement.focus();
        const metaDescrEl = document.querySelector('meta[name="description"]');
        const metaOGDescrEl = document.querySelector('meta[property="og:description"]');
        metaDescrEl?.setAttribute('content', this.pickedFolder.name);
        metaOGDescrEl?.setAttribute('content', this.pickedFolder.name);
    }
    isFolderOpen(folder) {
        return (this.pickedFolder &&
            (this.pickedFolder.id == folder.id ||
                (this.pickedFolder.parents != null &&
                    this.pickedFolder.parents.filter((x) => x.id == folder.id).length > 0) ||
                this.openFoldersInTree.filter((x) => x == folder.id).length > 0));
    }
    /**
     * Render component
     * @returns {TemplateResult} Template
     */
    render() {
        const liveVideos = this.liveVideos.map((video) => ({
            id: video.id,
            name: video.title,
            description: video.description,
            poster: video.poster,
            length: null,
            uploaded: video.liveAt
        }));
        const listItems = [...liveVideos, ...this.videos];
        return html ` <section class="video-list-page"> <div class="container"> <div class="file-tree"> <p-folder-tree slot="sidebar" tree-id="folder-tree" heading=${dictionary(this.culture, 'videoListPage', 'categories')} > ${this.folderTree?.filter((f) => f.depth == 0)?.map((folder) => html `
                    <p-folder
                      @p-folder-select=${(e) => this.pickFolder(e, folder)}
                      @p-folder-toggle-open=${() => {
            folder.open = !folder.open;
            this.requestUpdate();
        }}
                      hide-icon
                      ?selected=${folder.id == this.folderId}
                      ?open=${folder.hasChildren && (this.isFolderOpen(folder) || folder.open)}
                      folder-id=${folder.id}
                      level=${folder.depth}
                      ?has-sub-folders=${folder.hasChildren}
                      folder-title=${folder.name}
                      culture=${this.culture}
                    >
                      ${folder.name}
                      ${folder.hasChildren && (this.isFolderOpen(folder) || folder.open)
            ? this.subFolders(folder.id, this.folderTree)
            : ''}
                    </p-folder>
                  `)}
            </p-folder-tree>
          </div>
          <div class="main">
            <p-breadcrumbs culture=${this.culture}>
              ${this.pickedFolder?.parents
            ? this.pickedFolder?.parents.map((parent) => html ` <p-breadcrumb-item link="${this.baseUrl}/${parent.id}" >${parent.name}</p-breadcrumb-item > `)
            : ''}
              <p-breadcrumb-item currentPage link="${this.baseUrl}/${this.pickedFolder?.id}"
                >${this.pickedFolder?.name}</p-breadcrumb-item
              >
            </p-breadcrumbs>
            <header
              class="video-header"
              aria-label=${dictionary(this.culture, 'videoListPage', 'ariaVideoCategory')}
            >
              ${this.pickedFolder?.name ? html ` <h1>${this.pickedFolder.name}</h1> ` : ''}
              <span class="items" role="text"
                >${listItems.length}
                ${listItems.length == 1
            ? dictionary(this.culture, 'videoListPage', 'video')
            : dictionary(this.culture, 'videoListPage', 'videos')}</span
              >
            </header>
            <ul class="video-listing">
              ${this.liveVideos && this.liveVideos.length > 0
            ? this.liveVideos.map((video) => html ` <li> <p-video-item culture=${this.culture} heading-tag="h2" ?is-live=${video.status == 'BROADCASTING'} ?is-upcoming=${video.status == 'PENDING'} ?ended=${video.status == 'FINISHED'} link=${this.LiveBaseUrl + '/' + video.id} video-id=${video.id} summary=${video.description} heading=${video.title} poster=${video.poster} date=${video.liveAt} > </p-video-item> </li> `)
            : ''}
              ${this.videos && this.videos.length > 0
            ? this.videos.map((video) => html ` <li> <p-video-item culture=${this.culture} heading-tag="h2" link=${this.videoBaseUrl + '/' + video.id} video-id=${video.id} summary=${video.description} heading=${video.name} poster=${video.poster} duration=${this.showRuntime ? ifDefined(video.length) : ''} > </p-video-item> </li> `)
            : ''}
            </ul>
          </div>
        </div>
      </section>
    `;
    }
};
__decorate([
    property()
], PVideoListPage.prototype, "accessToken", void 0);
__decorate([
    property()
], PVideoListPage.prototype, "folderTree", void 0);
__decorate([
    property()
], PVideoListPage.prototype, "videos", void 0);
__decorate([
    property()
], PVideoListPage.prototype, "liveVideos", void 0);
__decorate([
    property()
], PVideoListPage.prototype, "pickedFolder", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'folder-id' })
], PVideoListPage.prototype, "folderId", void 0);
__decorate([
    property({ type: Number, reflect: true })
], PVideoListPage.prototype, "items", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoListPage.prototype, "heading", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'video-base-url' })
], PVideoListPage.prototype, "videoBaseUrl", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'live-base-url' })
], PVideoListPage.prototype, "LiveBaseUrl", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'base-url' })
], PVideoListPage.prototype, "baseUrl", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'show-latest' })
], PVideoListPage.prototype, "showLatest", void 0);
__decorate([
    property({ type: String })
], PVideoListPage.prototype, "culture", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'show-runtime' })
], PVideoListPage.prototype, "showRuntime", void 0);
__decorate([
    query('p-folder-tree')
], PVideoListPage.prototype, "folderTreeElement", void 0);
__decorate([
    query('.video-header')
], PVideoListPage.prototype, "videoHeaderElement", void 0);
PVideoListPage = __decorate([
    customElement('p-video-list-page')
    /*
      TODO: fix error message if no folders is avaible
    */
    /**
     * PVideoListPage component
     *
     * @class PVideoListPage
     * @typedef {PVideoListPage}
     * @extends {LitElement}
     */
], PVideoListPage);
export { PVideoListPage };
